import { render, staticRenderFns } from "./DatatableSuperAdmins.vue?vue&type=template&id=7a7f1b8c&"
import script from "./DatatableSuperAdmins.vue?vue&type=script&lang=js&"
export * from "./DatatableSuperAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports